<h3>
  <span i18n="@@did-avatar-tab-title">D-ID Avatar</span>
</h3>
<app-submenu [items]="this.submenuService.SUBMENU_FOR_CONFIGURATION"></app-submenu>

<!-- Eingabezeile -->
<h3
  class="mt-4"
  i18n="@@prompt-options"
>Eingabezeile</h3>
<app-form-for-boolean
  [label]="this.showPrompt"
  [(value)]="this.config.promptbarActive"
  [colClass]="'col-3'"
  (valueChange)="saveConfig()"
></app-form-for-boolean>
<app-form-for-boolean
  [label]="this.voiceInput"
  [(value)]="this.config.voiceInputActive"
  [colClass]="'col-3'"
  (valueChange)="saveConfig()"
>
  <app-hint i18n="@@hint-mic-usage-avatar">
    Das Mikrofon verbindet sich immer automatisch, sobald der Avatar verbunden ist. Ist diese Option aktiviert, hört der
    Bot sofort zu. Ist sie deaktiviert, bleibt das Mikrofon zunächst stummgeschaltet und du kannst es manuell
    aktivieren.
  </app-hint>
</app-form-for-boolean>
<app-form-for-boolean
  [label]="this.redirectChat"
  [(value)]="this.config.switchToChat"
  [colClass]="'col-3'"
  (valueChange)="saveConfig()"
>
  <app-hint i18n="@@hint-swap-to-chat">
    Zusätzlicher Knopf, um zum Chat-Bot zu wechseln
  </app-hint>
</app-form-for-boolean>
<app-form-for-boolean
  [label]="this.redirectVoice"
  [(value)]="this.config.switchToVoice"
  [colClass]="'col-3'"
  (valueChange)="saveConfig()"
>
  <app-hint i18n="@@hint-swap-to-voice">
    Zusätzlicher Knopf, um zum Audio-Bot zu wechseln
  </app-hint>
</app-form-for-boolean>
<app-form-for-boolean
  [label]="this.cancelThinking"
  [(value)]="this.config.cancelBotThinkingActive"
  [colClass]="'col-3'"
  (valueChange)="saveConfig()"
>
  <app-hint i18n="@@hint-cancel-thinking">
    Aktuell laufende Bot-Bearbeitung abbrechen
  </app-hint>
</app-form-for-boolean>

<h3
  class="mt-5"
  i18n="@@avatar-selection"
>Avatar-Auswahl</h3>

@if (this.myAvatars.length > 0) {
<h4 i18n="@@did-my-avatars">Meine Avatare</h4>
<div>
  <div class="avatar-grid my-avatars">
    @for (avatar of this.myAvatars; track avatar; let i = $index) {
    <div
      (click)="selectAvatar(avatar)"
      class="avatar-card rounded-3 overflow-hidden cursor-pointer"
      [ngClass]="{
          'selected': this.config.avatarId === avatar.id,
          'ms-0': i === 0,
          'me-0': i === this.myAvatars.length - 1
        }"
    >
      <div
        class="avatar-inner"
        [ngStyle]="getInnerStyle(avatar.id)"
      >
        @if (avatar.isGreenscreen && this.config.useGreenscreen && this.config.backgroundUrl) {
        <div
          class="avatar-inner-bg"
          [style.background-image]="'url(' + this.config.backgroundUrl + ')'"
        ></div>
        }
        <img
          [src]="avatar.previewUrl"
          class="avatar-inner-img"
          [class.chroma-source]="this.chromaKeyedIds().has(avatar.id)"
          alt=""
          (load)="chromaKeyPreview(avatar, previewCanvas)"
        />
        <canvas
          #previewCanvas
          class="avatar-inner-img"
        ></canvas>
      </div>
      <span
        class="avatar-name text-center position-absolute bottom-0 w-100"
        [ngClass]="{
            'bg-primary text-white': this.config.avatarId === avatar.id,
            'bg-white': this.config.avatarId !== avatar.id
          }"
      >{{ avatar.name }}</span>
    </div>
    }
  </div>
</div>
}

<h4
  class="mt-3"
  i18n="@@did-standard-avatars"
>Standard-Avatare</h4>
<div>
  <div class="avatar-grid catalog-avatars">
    @for (avatar of this.standardAvatars; track avatar; let i = $index) {
    <div
      (click)="selectAvatar(avatar)"
      class="avatar-card rounded-3 overflow-hidden cursor-pointer"
      [ngClass]="{
        'selected': this.config.avatarId === avatar.id,
        'ms-0': i === 0,
        'me-0': i === this.standardAvatars.length - 1
      }"
    >
      <div
        class="avatar-inner"
        [ngStyle]="getInnerStyle(avatar.id)"
      >
        @if (avatar.isGreenscreen && this.config.useGreenscreen && this.config.backgroundUrl) {
        <div
          class="avatar-inner-bg"
          [style.background-image]="'url(' + this.config.backgroundUrl + ')'"
        ></div>
        }
        <img
          [src]="avatar.previewUrl"
          class="avatar-inner-img"
          [class.chroma-source]="this.chromaKeyedIds().has(avatar.id)"
          alt=""
          (load)="chromaKeyPreview(avatar, previewCanvas)"
        />
        <canvas
          #previewCanvas
          class="avatar-inner-img"
        ></canvas>
      </div>
      <span
        class="avatar-name text-center position-absolute bottom-0 w-100"
        [ngClass]="{
          'bg-primary text-white': this.config.avatarId === avatar.id,
          'bg-white': this.config.avatarId !== avatar.id
        }"
      >{{ avatar.name }}</span>
    </div>
    }
  </div>
</div>

<!-- Hintergrund / Greenscreen -->
<h3
  class="mt-5"
  i18n="@@avatar-background-url"
>Hintergrund</h3>
<app-form-for-boolean
  [label]="this.greenscreen"
  [(value)]="this.config.useGreenscreen"
  [colClass]="'col-3'"
  [isDisabled]="!this.selectedAvatarIsGreenscreenCapable || this.config.fullscreenConfig?.active"
  (valueChange)="saveConfig()"
>
  <app-hint i18n="@@hint-greenscreen-mode">
    Aktiviert den Greenscreen-Filter (Chroma-Key). Nur verfügbar, wenn der gewählte Avatar einen
    echten grünen Hintergrund hat.
  </app-hint>
  @if (this.config.fullscreenConfig?.active) {
  <app-hint i18n="@@hint-greenscreen-forced-by-fullscreen">
    Im Fullscreen-Modus ist Greenscreen immer aktiv.
  </app-hint>
  }
</app-form-for-boolean>
<div class="row align-items-center mb-3 mt-2">
  <div class="col-3">
    <span i18n="@@background-url">Hintergrund-URL</span>
    <app-hint i18n="@@hint-avatar-background">
      URL zu einem Hintergrundbild für den Avatar. Wird nur genutzt, wenn Greenscreen aktiv ist.
    </app-hint>
  </div>
  <div class="col-6 lock-sensitive">
    <input
      pInputText
      class="w-100"
      [(ngModel)]="this.config.backgroundUrl"
      (ngModelChange)="saveConfig()"
      [placeholder]="'https://...'"
      [disabled]="!this.config.useGreenscreen"
    />
  </div>
</div>

<!-- Fullscreen-Modus -->
<h3
  class="mt-5"
  i18n="@@fullscreen-mode-title"
>Fullscreen-Modus</h3>

<app-form-for-boolean
  [label]="this.fullscreenMode"
  [(value)]="this.config.fullscreenConfig!.active"
  [colClass]="'col-3'"
  (valueChange)="toggleFullscreen()"
>
  <app-hint i18n="@@hint-fullscreen-mode">
    Zeigt den Avatar in einem eigenen Vollbild-Layout mit konfigurierbarem Header, Hintergrundbild über die
    komplette Fläche und allen Buttons/Eingabefeldern im Footer.
  </app-hint>
  @if (this.config.fullscreenConfig?.active && !this.selectedAvatarIsGreenscreenCapable) {
  <app-hint i18n="@@hint-fullscreen-no-greenscreen-avatar">
    Der gewählte Avatar unterstützt keinen echten grünen Hintergrund. Ohne Greenscreen wird der Avatar
    im Fullscreen-Modus nicht freigestellt dargestellt - wähle einen Avatar mit Greenscreen-Unterstützung.
  </app-hint>
  }
</app-form-for-boolean>

@if (this.config.fullscreenConfig?.active) {
<div class="row align-items-center mb-3">
  <div class="col-3">
    <span i18n="@@fullscreen-header-slot-left">Header links</span>
  </div>
  <div class="col-auto">
    <p-selectbutton
      [options]="this.headerSlotKindOptions"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="this.config.fullscreenConfig!.header.left.kind"
      [unselectable]="true"
      (ngModelChange)="saveConfig()"
    ></p-selectbutton>
  </div>
  <div class="col lock-sensitive">
    @if (this.config.fullscreenConfig!.header.left.kind !== 'none') {
    <input
      pInputText
      class="w-100"
      [(ngModel)]="this.config.fullscreenConfig!.header.left.value"
      [ngModelOptions]="{updateOn: 'blur'}"
      (ngModelChange)="saveConfig()"
      [placeholder]="this.config.fullscreenConfig!.header.left.kind === 'image' ? 'https://...' : ''"
    />
    }
  </div>
</div>
<div class="row align-items-center mb-3">
  <div class="col-3">
    <span i18n="@@fullscreen-header-slot-center">Header Mitte</span>
  </div>
  <div class="col-auto">
    <p-selectbutton
      [options]="this.headerSlotKindOptions"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="this.config.fullscreenConfig!.header.center.kind"
      [unselectable]="true"
      (ngModelChange)="saveConfig()"
    ></p-selectbutton>
  </div>
  <div class="col lock-sensitive">
    @if (this.config.fullscreenConfig!.header.center.kind !== 'none') {
    <input
      pInputText
      class="w-100"
      [(ngModel)]="this.config.fullscreenConfig!.header.center.value"
      [ngModelOptions]="{updateOn: 'blur'}"
      (ngModelChange)="saveConfig()"
      [placeholder]="this.config.fullscreenConfig!.header.center.kind === 'image' ? 'https://...' : ''"
    />
    }
  </div>
</div>
<div class="row align-items-center mb-3">
  <div class="col-3">
    <span i18n="@@fullscreen-header-slot-right">Header rechts</span>
  </div>
  <div class="col-auto">
    <p-selectbutton
      [options]="this.headerSlotKindOptions"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="this.config.fullscreenConfig!.header.right.kind"
      [unselectable]="true"
      (ngModelChange)="saveConfig()"
    ></p-selectbutton>
  </div>
  <div class="col lock-sensitive">
    @if (this.config.fullscreenConfig!.header.right.kind !== 'none') {
    <input
      pInputText
      class="w-100"
      [(ngModel)]="this.config.fullscreenConfig!.header.right.value"
      [ngModelOptions]="{updateOn: 'blur'}"
      (ngModelChange)="saveConfig()"
      [placeholder]="this.config.fullscreenConfig!.header.right.kind === 'image' ? 'https://...' : ''"
    />
    }
  </div>
</div>
}

<!-- Individueller CSS -->
<h3
  class="mt-5"
  i18n="@@css-individual"
>Individueller CSS</h3>
<app-codemirror-css
  [instruction]="this.rss.botConfig.customDidAvatarCss"
  [rows]="13"
  [botlyContext]="'D-ID Avatar-Bot'"
  [placeholder]="this.enterCustomCss"
  (finish)="this.rss.botConfig.customDidAvatarCss = $event; this.rss.saveBotConfigField('customDidAvatarCss')"
></app-codemirror-css>